<template>
  <v-dialog
    v-model="editDialog"
    max-width="800"
    persistent
  >
    <validation-observer v-slot="{ handleSubmit }">
      <v-card class="text-center">
        <v-card-title class="text-sm-left font-weight-bold">
          Cập nhật lịch làm việc
          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="closeDialog"
          >
            mdi-close
          </v-icon>
          <template v-if="errorMessage">
            <v-alert
              type="error"
            >
              {{ errorMessage }}
            </v-alert>
          </template>
        </v-card-title>
        <v-card-text class="px-6 pb-0">
          <v-row class="align-center">
            <v-col
              cols="12"
              md="12"
              class="pt-0"
            >
              <v-text-field
                v-model="scheduleDetail.user"
                label="Tên nhân viên"
                disabled
                color="primary"
              />
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-menu
                ref="datePicker"
                v-model="datePicker"
                :close-on-content-click="false"
                :return-value.sync="scheduleDetail.date"
                transition="scale-transition"
                offset-y
                landscape="false"
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <!--  after: afterDate, -->
                  <validation-provider
                    v-slot="{ errors }"
                    name="Ngày làm việc"
                    :rules="{
                      required: true,
                     
                    }"
                    :immediate="false"
                  >
                  <v-text-field
                    v-model="scheduleDetail.date"
                    color="primary"
                    label="Ngày làm việc *"
                    :error-messages="errors"
                    prepend-icon="mdi-calendar-outline"
                    readonly
                    v-on="on"
                    disabled
                  />
                  </validation-provider>
                </template>

                <v-date-picker
                  v-model="scheduleDetail.date"
                  color="secondary"
                  scrollable
                  @change="$refs.datePicker.save(scheduleDetail.date), datePicker = false"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              md="12"
              class="pt-0"
            >
              <validation-provider
                v-slot="{ errors }"
                class="mb-2"
                name="Ca làm việc"
                rules="required"
              >
              <v-autocomplete
                v-model="scheduleDetail.shift"
                :items="shiftList"
                label="Ca làm việc *"
                item-text="text"
                item-value="value"
                :error-messages="errors"
                
              >
                <template v-slot:selection="data">
                  <v-chip
                    class="bg-transparent px-0 ma-0"
                    v-bind="data.attrs"
                    :input-value="data.selected"
                  >
                    <v-avatar
                      class="s-shift"
                      left
                    >
                      <span
                        class="bg-schedule-title"
                        :style="{background: data.item.color}"
                      />
                    </v-avatar>
                    {{ data.item.text }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <v-list-item-content>
                    {{ data.item.text }}
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12" class="pt-0">
              <v-checkbox
                v-model="isOff"
                label="Xin Nghỉ"
                :disabled="!ableToUpdate"
                @change="handleIsOff"
              />
                <template v-if="isOff">
                  <div style="border-top: 1px solid #d2d2d2">
                    <v-radio-group :disabled="!ableToUpdate" row v-model="scheduleDetail.status">
                      <v-radio label="Xin nghỉ một phần"  :value="scheduleStatus.HALFWAY_OFF"></v-radio>
                      <v-radio label="Xin nghỉ toàn bộ"  :value="scheduleStatus.OFF"></v-radio>
                    </v-radio-group>
                  </div>
                </template>
            </v-col>
          </v-row>
          <v-row
            v-if="scheduleDetail.status === 'halfway_off'"
            class="align-center"
          >
            <v-col
              cols="12"
              class="pt-0"
            >
              <v-row class="align-center">
                <v-col
                  cols="12"
                  md="6"
                  class="pt-0"
                >
                  <v-dialog
                    ref="startHour"
                    v-model="startTime"
                    :return-value.sync="scheduleDetail.startHour"
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="Giờ bắt đầu"
                      >
                      <v-text-field
                        v-model="scheduleDetail.startHour"
                        label="Giờ bắt đầu làm việc *"
                        prepend-icon="mdi-calendar-outline"
                        readonly
                        :error-messages="errors"
                        v-on="on"
                        :disabled="!ableToUpdate"
                      />
                      </validation-provider>
                    </template>
                    <v-time-picker
                      v-if="startTime"
                      v-model="scheduleDetail.startHour"
                      full-width
                      :max="maxStartHour"
                      :min="minHour"
                      format="24hr"
                      :allowed-minutes="[0, 15, 30, 45]"
                    >
                      <div class="d-flex justify-space-between">
                        <v-btn small color="success" class="mr-0 ml-3" @click="$refs.startHour.save(scheduleDetail.startHour)">Đồng ý</v-btn>
                        <v-btn small color="primary" class="ml-0 mr-3" @click="startTime = false">Hủy</v-btn>
                      </div>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="pt-0"
                >
                  <v-dialog
                    ref="endHour"
                    v-model="endTime"
                    :return-value.sync="scheduleDetail.endHour"
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <validation-provider
                        v-slot="{ errors }"
                        rules="required"
                        name="Giờ kết thúc"
                      >
                      <v-text-field
                        v-model="scheduleDetail.endHour"
                        label="Giờ kết thúc làm việc *"
                        prepend-icon="mdi-calendar-outline"
                        readonly
                        :error-messages="errors"
                        :disabled="!ableToUpdate"
                        v-on="on"
                      />
                      </validation-provider>
                    </template>
                    <v-time-picker
                      v-if="endTime"
                      v-model="scheduleDetail.endHour"
                      full-width
                      :min="minEndHour"
                      :max="maxHour"
                      format="24hr"
                      :allowed-minutes="[0, 15, 30, 45]"
                    >
                      <div class="d-flex justify-space-between">
                        <v-btn small color="success" class="mr-0 ml-3" @click="$refs.endHour.save(scheduleDetail.endHour)">Đồng ý</v-btn>
                        <v-btn small color="primary" class="ml-0 mr-3" @click="endTime = false">Hủy</v-btn>
                      </div>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" class="pt-0 pb-0 pl-1">
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    name="Ghi chú"
                  >
                  <v-textarea
                    v-model="scheduleDetail.description"
                    class="px-3"
                    label="Ghi Chú *"
                    color="primary"
                    placeholder="Nội dung"
                    :error-messages="errors"
                    :disabled="!ableToUpdate"
                  />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-row>
            <v-col cols="12" md="6" class="pt-0 pb-0">
              <div class="btn-group-schedule text-left pl-4">
                <v-btn
                        v-if="showButtonUpdate && checkAuthorization('schedule_update')"
                        color="success"
                        medium
                        class="ma-0 mr-3"
                        @click.prevent="handleSubmit(update)"
                        :disabled="!ableToUpdate"
                >
                  Lưu lại
                </v-btn>
                <v-btn
                        medium
                        class="ml-0 mr-3 mb-0"
                        color="primary"
                        @click="closeDialog"
                >
                  Hủy bỏ
                </v-btn>
              </div>
            </v-col>
            <v-col v-if="showButtonUpdate && checkAuthorization('schedule_delete')" cols="12" md="6" class="pt-0 pb-0">
              <div class="btn-schedule-delete text-right pr-4">
                <v-btn
                        medium
                        class="ma-0"
                        color="default"
                        @click="deleteSchedule(scheduleDetail)"
                >
                  Xóa lịch
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>
<script>
  import TokenService from '../../helpers/token';
  import RepositoryFactory from '@/repositories/RepositoryFactory'
  import * as moment from 'moment'
  import { shiftList, scheduleStatus, shiftTimes } from '../../helpers/constants'
  import { formatHour } from '../../helpers/utils'
  const ScheduleRepository = RepositoryFactory.get('schedule')
  export default {

    data () {
      return {
        datePicker: false,
        endTime: false,
        startTime: false,
        editDialog: false,
        isOff: false,
        scheduleDetail: {},
        errorMessage: '',
        shiftList,
        scheduleStatus,
        shiftTimes,
        ableToUpdate: true,
        oldShift: '',
        oldDate: '',
        minHour: '',
        maxHour: '',
      }
    },
    computed: {
      showButtonUpdate() {
        if (this.isManager() || this.checkAuthorization('schedule_view_all')) {
          return true;
        }
        const dataUser = TokenService.getUser() || {};
        if (this.isStaff()) {
          const date = new Date();
          const firstDayMonthNext = new Date(date.getFullYear(), date.getMonth() +1, 1);
          return new Date(this.oldDate).getTime() > firstDayMonthNext.getTime();
        }
        return this.scheduleDetail.departmentId == dataUser.departmentId;
      }, 
      minEndHour () {
        return this.scheduleDetail.startHour ?
          moment(this.scheduleDetail.startHour, [moment.ISO_8601, 'HH:mm']).subtract(-15, "minutes").format('HH:mm')
          : this.minHour
      },
      maxStartHour () {
        return this.scheduleDetail.endHour ?
          moment(this.scheduleDetail.endHour, [moment.ISO_8601, 'HH:mm']).subtract(-15, "minutes").format('HH:mm')
          : this.maxHour
      },
    },
    created () {
      Bus.$on('schedule-show-edit-form', (scheduleDetail) => {
        this.scheduleDetail = scheduleDetail
        this.oldShift = scheduleDetail.shift
        this.oldDate = scheduleDetail.date
        this.editDialog = true
        if(scheduleDetail.status === scheduleStatus.HALFWAY_OFF) {
          this.scheduleDetail.startHour = moment(this.scheduleDetail.startHour, [moment.ISO_8601, 'HH:mm']).format("HH:mm")
          this.scheduleDetail.endHour = moment(this.scheduleDetail.endHour, [moment.ISO_8601, 'HH:mm']).format("HH:mm")
          // this.scheduleDetail.endHour = formatHour(scheduleDetail.endHour)
          this.isOff = true
          this.ableToUpdate = true
        } else if(scheduleDetail.status === scheduleStatus.OFF) {
          this.isOff = true
          this.ableToUpdate = true
          this.scheduleDetail.startHour = null
          this.scheduleDetail.endHour = null
        } else {
          this.isOff = false
          this.ableToUpdate = true
          this.scheduleDetail.startHour = null
          this.scheduleDetail.endHour = null
        }
        this.minHour = _.get(this.shiftTimes, `${this.oldShift}.start`, '')
        this.maxHour = _.get(this.shiftTimes, `${this.oldShift}.end`, '')
      })
    },
    methods: {
      async deleteSchedule(scheduleDetail) {
        const id = this.scheduleDetail.scheduleId
        this.$swal({
          title: 'Xóa lịch làm việc',
          text: 'Bạn có thực sự muốn xóa ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            // const loader = this.$loading.show()
            this.appLoadingData(true)
            const respond = await ScheduleRepository.delete(id)
            // loader.hide()
            this.appLoadingData(false)
            if (_.get(respond, 'success', false)) {
              this.$swal({
                        title: 'Đã xóa thành công !',
                        confirmButtonText: 'Đồng ý',
                      },
              ).then(() => {
                this.editDialog = false
                Bus.$emit('schedule-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
      },
      handleIsOff() {
        if(!this.isOff) {
          this.scheduleDetail.status = ''
        } else {
          this.scheduleDetail.status = this.scheduleStatus.OFF
          this.scheduleDetail.date = this.oldDate
          this.scheduleDetail.shift = this.oldShift
        }
      },
      closeDialog () {
        this.editDialog = false
        this.errorMessage = ''
      },
      async update () {
        if(this.isOff) {
            // Thuc hien xin nghi
            let a = this.scheduleDetail.startHour
            let b = this.scheduleDetail.endHour
            const scheduleStatus = {
              status: this.scheduleDetail.status,
              description: _.trim(this.scheduleDetail.description),
              startHour: this.scheduleDetail.status === this.scheduleStatus.HALFWAY_OFF ? a.concat(':00') : null,
              endHour: this.scheduleDetail.status === this.scheduleStatus.HALFWAY_OFF ? b.concat(':00') : null,
            }
            this.$swal({
              title: 'Xin nghỉ',
              text: 'Bạn có thực sự muốn xin nghỉ ?',
              type: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Đồng ý',
              cancelButtonText: 'Hủy bỏ',
            }).then(async (result) => {
              if (result.value) {
                // const loader = this.$loading.show()
                this.appLoadingData(true)
                const response = await ScheduleRepository.updateStatus(this.scheduleDetail.scheduleId, scheduleStatus)
                // loader.hide()
                this.appLoadingData(false)
                if (_.get(response, 'success', false)) {
                  this.$swal({
                            title: 'Xin nghỉ thành công !',
                            confirmButtonText: 'Đồng ý',
                          },
                  ).then(() => {
                    this.editDialog = false
                    Bus.$emit('schedule-list-reload')
                    // window.location.reload()
                  })
                } else {
                  this.$swal({
                    type: 'error',
                    title: 'Lỗi !',
                    text: _.get(response, 'message', ''),
                  })
                }
              }
            })
        } else {
          const scheduleDetail = {
            shift: this.scheduleDetail.shift,
            date: this.scheduleDetail.date,
          }
          this.$swal({
            title: 'Cập nhật lịch làm việc',
            text: 'Bạn có thực sự muốn cập nhật ?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Đồng ý',
            cancelButtonText: 'Hủy bỏ',
          }).then(async (result) => {
            if (result.value) {
              // const loader = this.$loading.show()
              this.appLoadingData(true)
              const response = await ScheduleRepository.update(this.scheduleDetail.scheduleId, scheduleDetail)
              // loader.hide()
              this.appLoadingData(false)
              if (_.get(response, 'success', false)) {
                this.$swal({
                          title: 'Cập nhật thành công !',
                          confirmButtonText: 'Đồng ý',
                        },
                ).then(() => {
                  this.editDialog = false
                  Bus.$emit('schedule-list-reload')
                })
              } else {
                this.$swal({
                  type: 'error',
                  title: 'Lỗi !',
                  text: _.get(response, 'message', ''),
                })
              }
            }
          })
        }
      },
    },
  }
</script>
<style scoped>

</style>
